import { render } from "./ListOfClassAnnouncements.vue?vue&type=template&id=61ba4016"
import script from "./ListOfClassAnnouncements.vue?vue&type=script&lang=js"
export * from "./ListOfClassAnnouncements.vue?vue&type=script&lang=js"

import "./ListOfClassAnnouncements.vue?vue&type=style&index=0&id=61ba4016&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__